import { useState, useEffect } from "react";
import { authHeader } from "../../_helpers/auth-header";
import { otlAPIs } from "../api-endpoints/OtlServiceEndpoints";

// Get a list of locations
export async function getOtlEntities() {
  const url = otlAPIs().get_otl_entities;

  const config = {
    method: "GET",
    headers: authHeader({ authJson: true, authForm: false, guestJson: false }),
  };

  let erMessage = "Get Entities error";

  let response = await fetch(url, config);

  if (response.ok) {
    response = await response.json();
  } else {
    response = [];
    console.log(erMessage);
  }
  return response;
}

// GET LOCATIONS
export default function useEntities(show) {
  const [loading, setLoading] = useState(true);
  const [entities, setEntities] = useState([]);

  useEffect(() => {
    if (show) {
      setLoading(true);
      getOtlEntities()
        .then((entitiesRes) => {
          const _entities = entitiesRes;
          setEntities(_entities);
          setLoading(false);
        })
        .catch((e) => {
          setLoading(false);
        });
    }
  }, [show]);
  return {
    entityList: {
      data: entities,
      loading: loading,
      get: getOtlEntities,
      set: setEntities,
    },
  };
}
